import { snackbar } from "@bcmi-labs/art-ui"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { routeGuard } from "@/lib/routing/beforeLoad"
import { getRecap } from "@/lib/routing/loader"

export const Route = createFileRoute("/_authlayout/_header/triggers/new/")({
  staticData: {
    title: "New Thing"
  },
  beforeLoad: async ({ context }) => {
    await routeGuard(context, { permission: { flag: "iot:trigger::create", fallbackRoute: { to: "/triggers" } } })
  },
  loader: async ({ context, preload }) => {
    if (preload) return

    const user = await context.authClient.getUser()

    // This should not even be possible 🤷🏻
    if (!user) throw new Error("User not authenticated")

    const recap = await getRecap(context)

    if (!recap.features.triggers) {
      snackbar({
        message: "Your plan does not include access to Triggers. Please upgrade to create your first Trigger.",
        variant: "error"
      })
      redirect({ to: "/triggers", throw: true })
      return
    }

    if (recap.isAtQuota.triggers) {
      snackbar({
        message: "You have reached the maximum number of Triggers for your plan.",
        variant: "info"
      })
      redirect({ to: "/triggers", throw: true })
      return
    }
  }
})
